export default __webpack_public_path__ + "static/media/dashboard-next-invoice.bfd53b84.svg";